import { Grid } from '@mui/material';
import { ChipButton } from '@apigrowfinance/pbolt-chip-button';
import { Restricted } from '@apigrowfinance/pbolt-permission-provider';
import { RiSmartphoneLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { PhoneDetails } from '@clients/accountsClient';
import ContactDetails from '@components/contactDetails/ContactDetails';
import phoneNumberTypes from '@messages/phoneNumberTypes';
import getEnumTranslation from '@utils/getEnumTranslation';

type PhoneNumberRowProps = {
    phoneDetails: PhoneDetails;
    isLoading?: boolean;
    handleOnClickEdit?: (phoneId: number) => void;
};

const PhoneNumberRow = ({
    phoneDetails,
    isLoading = false,
    handleOnClickEdit,
}: PhoneNumberRowProps) => {
    const phoneType = phoneDetails?.type
        ? getEnumTranslation(phoneDetails?.type, {
              messages: phoneNumberTypes,
          })
        : '';

    return (
        <Grid container key={phoneDetails?.id}>
            <ContactDetails
                icon={<RiSmartphoneLine />}
                textBaseTestId="phone-type"
                textValue={phoneType}
                textLabel={
                    <FormattedMessage
                        id="AccountContactDetails.type"
                        defaultMessage="Type"
                    />
                }
                isLoading={isLoading}
            />
            <ContactDetails
                textBaseTestId="country-code"
                textValue={`+${phoneDetails?.country_code}`}
                textLabel={
                    <FormattedMessage
                        id="AccountContactDetails.countryCode"
                        defaultMessage="Country code"
                    />
                }
                isLoading={isLoading}
            />
            <ContactDetails
                textBaseTestId="area-code"
                textValue={phoneDetails?.area_code}
                textLabel={
                    <FormattedMessage
                        id="AccountContactDetails.areaCode"
                        defaultMessage="Area code"
                    />
                }
                isLoading={isLoading}
            />
            <ContactDetails
                textBaseTestId="phone-number"
                textValue={phoneDetails?.number}
                textLabel={
                    <FormattedMessage
                        id="AccountContactDetails.number"
                        defaultMessage="Number"
                    />
                }
                isLoading={isLoading}
            />
            <ContactDetails
                textBaseTestId="phone-extension"
                textValue={phoneDetails?.extension}
                textLabel={
                    <FormattedMessage
                        id="AccountContactDetails.extension"
                        defaultMessage="Extension"
                    />
                }
                isLoading={isLoading}
            />
            <Restricted to="edit.phoneNumber">
                <ChipButton
                    onClick={() => handleOnClickEdit(phoneDetails?.id)}
                    label={getEnumTranslation('edit')}
                    variant="editMenu"
                    isLoading={isLoading}
                    bordered
                />
            </Restricted>
        </Grid>
    );
};

export default PhoneNumberRow;
